import { Component, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { BreadcrumMenuService } from 'src/commons/services/breadCrumb/breadcrum-menu.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent {


  constructor (private router: Router, private menu: BreadcrumMenuService){}


}
